<template>
  <div class="Editoren">
  <div class="d-none d-sm-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">FAQ</li>
      </ol>
    </nav>
  </div>
   <div v-if="loading" class="d-flex justify-content-center mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <div v-for="faqKat in faqKategorien" :key="faqKat.id">
      <div v-if="faqKat.questions.length>0">
        <h3>{{ faqKat.name }}</h3>
        <div v-for="faq in faqKat.questions" :key="faq.id" class="accordion" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1 accordion-header"  role="tab">
              <b-button block v-b-toggle="myId(faq)" variant="white" class="text-left">{{ faq.frage }}</b-button>
            </b-card-header>
            <b-collapse :id="myId(faq)" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>{{ faq.antwort }}</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/basic'

export default {
  name: 'FAQ',
  methods: {
    myId (item) {
      return 'accordion-' + item.id
    },
    async update () {
      this.loading = true
      this.faqKategorien = await api.faq()
      this.loading = false
    }
  },
  data () {
    return {
      faqKategorien: [],
      loading: false
    }
  },
  mounted () {
    this.update()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/FAQ.vue